import { Button, BackTop, Divider, Form, Input } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Sticky from 'react-sticky-el';
import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';

export default function Step3({ ...props }) {
    const { setStep3, editData } = props;
    const { t } = useTranslation(['hr-policy', 'translation']);

    const onNextStep = () => {
        props?.form
            .validateFields()
            .then(() => {
                setStep3(true);
            })
            .catch(() => setStep3(false));
        props.nextStep();
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (editData) {
            let check = true;
            const allowKey = [
                'vendorPersonalDataTitleTh',
                'vendorPersonalDataTitleEn',
                'vendorPersonalDataContentTh',
                'vendorSourceTitleTh',
                'vendorSourceTitleEn',
                'vendorSourceContentTh',
            ];
            for (const [key, value] of Object.entries(
                editData?.vendorPersonalDataCollect
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                }
            }
            setStep3(check);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editData]);

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('Personal Data Collected and Source')}
            </div>
            <div className="text-gray-500 text-tiny">
                {t('policy.desEtc', { ns: 'translation' })}
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                name="vendorPersonalDataCollect"
                layout="vertical"
                form={props?.form}
                onValuesChange={(e, allFields) => {
                    let check = true;
                    const allowKey = [
                        'vendorPersonalDataTitleTh',
                        'vendorPersonalDataTitleEn',
                        'vendorPersonalDataContentTh',
                        'vendorSourceTitleTh',
                        'vendorSourceTitleEn',
                        'vendorSourceContentTh',
                    ];
                    for (const [key, value] of Object.entries(allFields)) {
                        if (allowKey.includes(key) && !value) {
                            check = false;
                        }
                    }
                    setStep3(check);
                }}
                initialValues={initial}
            >
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('Personal data collected and used')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorPersonalDataTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`1. ข้อมูลรายละเอียดส่วนตัว : ชื่อ-นามสกุล, วัน/เดือน/ปีเกิด, หมายเลขบัตรประจำตัวประชาชน, หมายเลขหนังสือเดินทาง, เพศ, อายุ, สัญชาติ, รูป ถ่าย, ลายมือชื่อ, สถานภาพสมรส และคู่สมรส\n2. ข้อมูลการติดต่อ : ที่อยู่, หมายเลขโทรศัพท์, อีเมล, LINE ID, หรือ บัญชี social media ต่างๆ\n3. ข้อมูลเกี่ยวกับการทำธุรกรรมและข้อมูลทางการเงิน : ประวัติการใช้บริการ, ข้อมูลการขอเข้าเมือง (VISA) และใบอนุญาตทำงาน (Work permit), สำเนาโฉนดที่ดิน, สำเนาทะเบียนบ้าน, หมายเลขบัญชีธนาคาร, หมายเลขบัตรเครดิต, ข้อมูลเกี่ยวกับสินเชื่อ\n4. ข้อมูลเกี่ยวกับการใช้งานระบบคอมพิวเตอร์ : หมายเลขประจำเครื่องคอมพิวเตอร์ (IP address), บัญชีผู้ใช้งาน, คุกกี้, ข้อมูลและประวัติการเข้าถึงแอปพลิเคชัน และเว็บไซต์ของบริษัท\n5. ข้อมูลเกี่ยวกับพนักงาน : ประวัติการศึกษา, ประวัติการทำงาน, สถานภาพสมรส, สถานะทางทหาร, ใบอนุญาตต่างๆ, ข้อมูลเกี่ยวกับสวัสดิการและผลประโยชน์ต่างๆ, ข้อมูลการปฏิบัติงานและข้อมูลทางวินัย, ข้อมูลบุคคลที่สาม (ครอบครัว, ผู้ค้ำประกัน, บุคคลอ้างอิง, บุคคลผู้ติดต่อในกรณีฉุกเฉิน), ข้อมูลประกันสังคม\n6. ข้อมูลส่วนบุคคลอ่อนไหว : ศาสนา, ข้อมูลสุขภาพ (เช่น หมู่เลือด, ประวัติสุขภาพ เป็นต้น), ข้อมูลพันธุกรรมหรือข้อมูลชีวภาพ (เช่น ลายนิ้วมือ เป็นต้น), พฤติกรรมทางเพศ`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorPersonalDataContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorPersonalDataTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input size="large" showCount maxLength={200} />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`1. Personal details: Name, Date of Birth, National ID Number, Passport Number, Gender, Age, Nationality, Photo, Signature, Marital Status and Spouse information.\n2. Contact information: Address, Phone Number, Email, LINE ID, or Social Media accounts.\n3. Transaction and Financial information: Service usage history, Visa and Work Permit information, Land Title Deed copy, House Registration copy, Bank account number, Credit card number, and loan information.\n4. Computer system usage information: Computer's IP address, User account, Cookies, Access history and records of the company's applications and websites.\n5. Employee information: Education history, Employment history, Marital status, Military status, Licenses, Information about benefits and compensation, Job performance and disciplinary records, Third-party information such as family members, Guarantors, References and Emergency contacts, and Social security information.\n6. Sensitive personal information: Religion, Health information (such as blood type, medical history), Genetic or biometric data (such as fingerprints), and Sexual orientation.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorPersonalDataContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Divider />
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('SourcesDataCollection')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorSourceTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`โดยบริษัทฯ อาจเก็บรวบรวมข้อมูลส่วนบุคคลของท่านทั้งทางตรงและทางอ้อมจากแหล่งข้อมูลอื่น ๆ เช่น เราอาจเก็บรวบรวมข้อมูลส่วนบุคคลของท่านโดยตรงในระหว่างกระบวนการสมัครงานหรือสัมภาษณ์งาน เมื่อเริ่มต้นจ้างงาน หรือตลอดระยะเวลาที่จ้างงาน หรือระยะเวลาตามสัญญาบริการที่เราทำกับนายจ้างของท่าน เพื่อเป็นส่วนหนึ่งของการจ้างงานหรือการจ้างบริการจากท่าน`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorSourceContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorSourceTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`The company may disclose or transfer your personal data to third parties located in Thailand or abroad. These third parties may have their own privacy policies governing how they collect, use, and/or disclose your personal data. You may review the privacy policy of these third parties to learn more about how they collect, use, and/or disclose your personal data as you will be subject to their respective privacy policies.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorSourceContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    {props.editMode ? (
                        <BtnSave
                            goToStep={props.goToStep}
                            loading={props.loading}
                        />
                    ) : (
                        <div className="flex items-center">
                            <Button
                                type="default"
                                size="large"
                                onClick={onPreviousStep}
                            >
                                <ArrowLeftOutlined />{' '}
                                {t('policy.PreviousStep', {
                                    ns: 'translation',
                                })}
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                onClick={onNextStep}
                                className="ml-4"
                            >
                                {t('policy.NextStep', { ns: 'translation' })}{' '}
                                <ArrowRightOutlined />
                            </Button>
                            <div
                                style={{ borderLeft: '1px solid #DBDBDB' }}
                                className="ml-6"
                            >
                                <Button
                                    onClick={props.saveDraft}
                                    className="text-[#1890FF]"
                                    type="link"
                                >
                                    {t('Save Draft')}
                                </Button>
                                <span>{t('to save the latest changes')}</span>
                            </div>
                        </div>
                    )}
                </Sticky>
            </Form>
            <BackTop style={{ zIndex: 100000 }}>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

const initial = {
    vendorPersonalDataCollectId: null,
    vendorPersonalDataTitleTh: 'ข้อมูลส่วนบุคคลที่จัดเก็บและนำไปใช้',
    vendorPersonalDataTitleEn: 'The personal data that is collected and used',
    vendorPersonalDataContentTh: '',
    vendorPersonalDataContentEn: '',
    vendorPersonalDataIsDisplay: true,
    vendorSourceTitleTh: 'แหล่งที่มา/วิธีการเก็บรวบรวมข้อมูล',
    vendorSourceTitleEn: 'Source of data collection',
    vendorSourceContentTh: '',
    vendorSourceContentEn: '',
    vendorSourceIsDisplay: true,
};
